import { render, staticRenderFns } from "./ComprehensivePlan.vue?vue&type=template&id=d0f3a3fa&scoped=true"
import script from "./ComprehensivePlan.vue?vue&type=script&lang=js"
export * from "./ComprehensivePlan.vue?vue&type=script&lang=js"
import style0 from "./ComprehensivePlan.vue?vue&type=style&index=0&id=d0f3a3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f3a3fa",
  null
  
)

export default component.exports